<template>
  <div class="pagina ativa" id="paginaProposta">
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:0;border-bottom:2px solid #4a5c2f;padding-bottom:10px;flex-wrap:wrap;gap:8px;">
      <div style="display:flex;align-items:center;gap:8px;font-size:22px;font-weight:bold;color:#4a5c2f;"><FileText :size="22" /> Proposta Comercial</div>
      <div style="display:flex;gap:8px;flex-wrap:wrap;">
        <button @click="limparPropostaAtual" style="display:inline-flex;align-items:center;gap:5px;margin:0;padding:8px 16px;font-size:13px;background:#888;"><Trash2 :size="13" /> Limpar</button>
        <button v-if="btnToggleSimVisivel" @click="toggleSimuladorNaProposta" style="display:inline-flex;align-items:center;gap:5px;margin:0;padding:8px 16px;font-size:13px;background:#2980b9;"><TrendingUp :size="13" /> {{ simVisivelNaProposta ? 'Ocultar Simulação' : 'Mostrar Simulação' }}</button>
        <button v-if="btnSoSimVisivel" @click="exportarSoSimulador" style="display:inline-flex;align-items:center;gap:5px;margin:0;padding:8px 16px;font-size:13px;background:#16a085;"><FileText :size="13" /> Só Simulação</button>
        <button @click="salvarPropostaAtual" style="margin:0;padding:8px 16px;font-size:13px;background:#27ae60;">{{ textoBtnSalvar }}</button>
        <button @click="gerarImagemProposta" style="display:inline-flex;align-items:center;gap:5px;margin:0;padding:8px 16px;font-size:13px;background:#3498db;"><Camera :size="13" /> Imagem</button>
        <button @click="gerarPDFProposta" style="display:inline-flex;align-items:center;gap:5px;margin:0;padding:8px 16px;font-size:13px;"><FileText :size="13" /> PDF</button>
      </div>
    </div>

    <!-- Abas internas -->
    <div style="display:flex;gap:0;border-bottom:2px solid #e0e0e0;margin:16px 0 20px;">
      <div @click="trocarAbaProposta('proposta')" :style="{ display: 'flex', alignItems: 'center', gap: '6px', padding: '10px 24px', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold', color: aba === 'proposta' ? '#4a5c2f' : '#888', borderBottom: aba === 'proposta' ? '3px solid #4a5c2f' : '3px solid transparent', marginBottom: '-2px', background: aba === 'proposta' ? 'white' : 'transparent' }"><FileText :size="14" /> Montar Proposta</div>
      <div @click="trocarAbaProposta('simulador')" :style="{ display: 'flex', alignItems: 'center', gap: '6px', padding: '10px 24px', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold', color: aba === 'simulador' ? '#4a5c2f' : '#888', borderBottom: aba === 'simulador' ? '3px solid #4a5c2f' : '3px solid transparent', marginBottom: '-2px', background: aba === 'simulador' ? 'white' : 'transparent' }"><TrendingUp :size="14" /> Simulador Embracon</div>
    </div>

    <!-- PAINEL SIMULADOR -->
    <div v-show="aba === 'simulador'">
      <div class="proposta-sim-grid" style="display:grid;grid-template-columns:380px 1fr;gap:24px;align-items:start;">
        <div style="background:white;border-radius:12px;padding:22px;box-shadow:0 2px 12px rgba(0,0,0,0.08);">
          <div style="display:flex;align-items:center;gap:7px;font-weight:bold;color:#4a5c2f;font-size:14px;margin-bottom:16px;"><Settings :size="15" /> Parâmetros da Simulação</div>

          <label style="font-size:11px;font-weight:bold;color:#888;text-transform:uppercase;">Tipo</label>
          <select v-model="sim.tipo" style="width:100%;padding:8px 10px;margin:4px 0 12px;border:1px solid #ddd;border-radius:6px;font-size:13px;">
            <option value="autoconv">Automóvel — Convencional</option>
            <option value="automais">Automóvel — Mais por Menos</option>
            <option value="imovconv">Imóvel — Convencional</option>
            <option value="imovmais">Imóvel — Mais por Menos</option>
          </select>

          <div v-show="sim.tipo === 'autoconv' || sim.tipo === 'automais'">
            <label style="font-size:11px;font-weight:bold;color:#888;text-transform:uppercase;">Categoria</label>
            <select v-model="sim.cat" style="width:100%;padding:8px 10px;margin:4px 0 12px;border:1px solid #ddd;border-radius:6px;font-size:13px;">
              <option value="auto">AUTOS/EQUIP.</option>
              <option value="pesados">PESADOS</option>
            </select>
          </div>

          <label style="font-size:11px;font-weight:bold;color:#888;text-transform:uppercase;">Valor do Crédito (R$)</label>
          <input type="text" v-model="simCreditoInput" @input="mascaraSimCredito" style="width:100%;padding:8px 10px;margin:4px 0 12px;border:1px solid #ddd;border-radius:6px;font-size:13px;" />

          <label style="font-size:11px;font-weight:bold;color:#888;text-transform:uppercase;">Prazo (meses)</label>
          <input type="number" v-model.number="sim.prazo" min="1" max="240" style="width:100%;padding:8px 10px;margin:4px 0 12px;border:1px solid #ddd;border-radius:6px;font-size:13px;" />

          <label style="font-size:11px;font-weight:bold;color:#888;text-transform:uppercase;">Taxa de Administração (%)</label>
          <input type="number" v-model.number="sim.taxa" step="0.01" style="width:100%;padding:8px 10px;margin:4px 0 12px;border:1px solid #ddd;border-radius:6px;font-size:13px;" />

          <label style="font-size:11px;font-weight:bold;color:#888;text-transform:uppercase;">Fundo de Reserva (%)</label>
          <input type="number" v-model.number="sim.fundo" step="0.01" style="width:100%;padding:8px 10px;margin:4px 0 12px;border:1px solid #ddd;border-radius:6px;font-size:13px;" />

          <label style="font-size:11px;font-weight:bold;color:#888;text-transform:uppercase;">Adm. Antecipada (%)</label>
          <input type="number" v-model.number="sim.antec" step="0.01" style="width:100%;padding:8px 10px;margin:4px 0 12px;border:1px solid #ddd;border-radius:6px;font-size:13px;" />

          <label style="font-size:11px;font-weight:bold;color:#888;text-transform:uppercase;">Diluição Taxa Antecipada (nº parcelas)</label>
          <select v-model.number="sim.dil" style="width:100%;padding:8px 10px;margin:4px 0 12px;border:1px solid #ddd;border-radius:6px;font-size:13px;">
            <option :value="1">1ª Parcela</option>
            <option :value="2">1ª e 2ª Parcelas</option>
            <option :value="4">1ª a 4ª Parcelas</option>
          </select>

          <div style="border:2px solid #2980b9;border-radius:10px;padding:14px;margin-top:4px;margin-bottom:16px;background:#f0f9ff;">
            <div style="font-size:11px;font-weight:bold;color:#2980b9;text-transform:uppercase;margin-bottom:4px;display:flex;align-items:center;gap:6px;">
              <LockOpen :size="12" /> Simulação 2 — Lance 50% / Livre
            </div>
            <div style="font-size:11px;color:#64748b;margin-bottom:10px;line-height:1.5;">
              25% embutido + quanto o cliente coloca de recurso próprio.<br>Informe abaixo o valor que o cliente vai entrar:
            </div>
            <label style="font-size:11px;font-weight:bold;color:#555;text-transform:uppercase;">Recursos Próprios do Cliente (R$)</label>
            <input type="text" v-model="simLanceRpInput" @input="mascaraSimLanceRp" style="width:100%;padding:8px 10px;margin:4px 0 8px;border:1px solid #2980b9;border-radius:6px;font-size:14px;background:white;font-weight:bold;" />
            <div :style="{ fontSize: '12px', color: lanceInfoCor, fontWeight: 'bold', padding: '8px 12px', background: 'white', border: '1px solid #bae6fd', borderRadius: '6px', textAlign: 'center' }" v-html="lanceInfoHtml"></div>
          </div>

          <button @click="simUsarNaProposta" style="display:flex;align-items:center;justify-content:center;gap:6px;width:100%;margin:0;padding:12px;font-size:14px;background:#27ae60;border-radius:8px;"><ArrowRight :size="15" /> Usar na Proposta</button>
        </div>

        <div style="background:white;border-radius:12px;padding:22px;box-shadow:0 2px 12px rgba(0,0,0,0.08);" v-html="simResultadoHtml"></div>
      </div>
    </div>

    <!-- PAINEL PROPOSTA -->
    <div v-show="aba === 'proposta'">
      <div class="proposta-grid" style="display:grid;grid-template-columns:440px 1fr;gap:24px;align-items:start;">
        <div style="background:white;border-radius:12px;padding:24px;box-shadow:0 2px 12px rgba(0,0,0,0.08);">
          <div style="display:flex;align-items:center;gap:7px;font-weight:bold;color:#4a5c2f;font-size:14px;margin-bottom:16px;"><Pencil :size="14" /> Dados da Proposta</div>

          <label style="font-size:12px;font-weight:bold;color:#555;">NOME DO CLIENTE</label>
          <input type="text" v-model="prNomeCliente" placeholder="Ex: João da Silva" style="width:100%;padding:9px;margin:3px 0 12px;border:1px solid #ddd;border-radius:6px;font-size:13px;" />

          <label style="font-size:12px;font-weight:bold;color:#555;">ADMINISTRADORA</label>
          <input type="text" v-model="prAdm" placeholder="Ex: EMBRACON" style="width:100%;padding:9px;margin:3px 0 12px;border:1px solid #ddd;border-radius:6px;font-size:13px;" />

          <div style="border-top:1px solid #eee;padding-top:14px;margin-top:4px;">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;">
              <span style="display:inline-flex;align-items:center;gap:6px;font-size:13px;font-weight:bold;color:#4a5c2f;"><CreditCard :size="14" /> Cartas / Opções</span>
              <button @click="adicionarCarta" style="margin:0;padding:6px 14px;font-size:12px;background:#4a5c2f;">+ Carta</button>
            </div>
            <div v-for="(carta, ci) in cartas" :key="ci" :style="{ border: '1px solid #e8e8e8', borderTop: '3px solid ' + cores[ci % cores.length], borderRadius: '10px', padding: '14px', marginBottom: '12px', background: 'white' }">
              <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:12px;">
                <div style="display:flex;align-items:center;gap:8px;">
                  <div :style="{ width: '8px', height: '8px', borderRadius: '50%', background: cores[ci % cores.length], flexShrink: 0 }"></div>
                  <span style="font-size:12px;font-weight:bold;color:#444;">Carta {{ ci + 1 }}</span>
                </div>
                <button v-if="cartas.length > 1" @click="removerCarta(ci)" style="margin:0;padding:3px 10px;font-size:11px;background:#fef2f2;color:#c0392b;border:1px solid #fca5a5;border-radius:5px;cursor:pointer;">Remover</button>
              </div>
              <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:10px;">
                <div>
                  <div style="font-size:9px;color:#aaa;text-transform:uppercase;margin-bottom:2px;">Segmento</div>
                  <select v-model="carta.segmento" style="width:100%;padding:6px 8px;border:1px solid #e0e0e0;border-radius:6px;font-size:12px;margin:0;background:white;">
                    <option v-for="s in segmentos" :key="s" :value="s">{{ s }}</option>
                  </select>
                </div>
                <div>
                  <div style="font-size:9px;color:#aaa;text-transform:uppercase;margin-bottom:2px;">Crédito (R$)</div>
                  <input type="text" v-model="carta.credito" @input="mascaraCredito($event, ci)" placeholder="Ex: 400.000,00" style="width:100%;padding:6px 8px;border:1px solid #e0e0e0;border-radius:6px;font-size:13px;margin:0;" />
                  <label style="display:flex;align-items:center;gap:6px;cursor:pointer;margin-top:6px;">
                    <input type="checkbox" v-model="carta.mostrarLiquido" style="width:14px;height:14px;cursor:pointer;" />
                    <span style="font-size:10px;color:#666;">Mostrar líquido no lance embutido</span>
                  </label>
                  <div style="font-size:10px;color:#4a5c2f;font-weight:700;margin-top:4px;">{{ (carta.credito && carta.mostrarLiquido !== false) ? ('Líquido no lance embutido (25%): ' + fmtBRL(parseVal(carta.credito) * 0.75)) : '' }}</div>
                </div>
                <div>
                  <div style="font-size:9px;color:#aaa;text-transform:uppercase;margin-bottom:2px;">Taxa Adm. (%)</div>
                  <input type="text" v-model="carta.taxa" placeholder="Ex: 18%" style="width:100%;padding:6px 8px;border:1px solid #e0e0e0;border-radius:6px;font-size:13px;margin:0;" />
                </div>
                <div>
                  <div style="font-size:9px;color:#aaa;text-transform:uppercase;margin-bottom:2px;">Fundo de Reserva (%)</div>
                  <input type="text" v-model="carta.fundo" placeholder="Ex: 2%" style="width:100%;padding:6px 8px;border:1px solid #e0e0e0;border-radius:6px;font-size:13px;margin:0;" />
                </div>
              </div>
              <div style="font-size:9px;color:#aaa;text-transform:uppercase;font-weight:bold;margin-bottom:6px;letter-spacing:.04em;">Parcelas</div>
              <div v-for="(g, gi) in carta.grupos" :key="gi" style="display:flex;gap:6px;margin-bottom:6px;align-items:flex-end;">
                <div style="flex:1;">
                  <div style="font-size:9px;color:#aaa;text-transform:uppercase;margin-bottom:2px;">Nº Parcelas</div>
                  <input type="text" v-model="g.qtd" placeholder="Ex: 12" style="width:100%;padding:6px 8px;border:1px solid #e0e0e0;border-radius:6px;font-size:13px;margin:0;" />
                </div>
                <div style="flex:1;">
                  <div style="font-size:9px;color:#aaa;text-transform:uppercase;margin-bottom:2px;">Valor Parcela (R$)</div>
                  <input type="text" v-model="g.valor" @input="mascaraGrupoValor($event, ci, gi)" placeholder="Ex: 800,00" style="width:100%;padding:6px 8px;border:1px solid #e0e0e0;border-radius:6px;font-size:13px;margin:0;" />
                </div>
                <button v-if="carta.grupos.length > 1" @click="removerGrupoCarta(ci, gi)" style="display:inline-flex;align-items:center;justify-content:center;margin:0;padding:5px 8px;background:#e0e0e0;color:#666;border:none;border-radius:6px;flex-shrink:0;cursor:pointer;"><X :size="12" /></button>
              </div>
              <button @click="adicionarGrupoCarta(ci)" style="margin:6px 0 0;padding:5px 0;font-size:11px;background:#f8f9f6;color:#4a5c2f;border:1px dashed #aaa;border-radius:6px;width:100%;cursor:pointer;">+ grupo de parcelas</button>
              <div style="margin-top:10px;">
                <label style="display:flex;align-items:center;gap:8px;cursor:pointer;margin-bottom:8px;">
                  <input type="checkbox" v-model="carta._seguroChecked" @change="toggleSeguro($event, ci)" style="width:16px;height:16px;cursor:pointer;" />
                  <span style="font-size:12px;color:#444;font-weight:bold;">Incluir Seguro na Parcela</span>
                </label>
                <div v-if="carta._seguroChecked" style="margin-bottom:8px;">
                  <div style="font-size:9px;color:#aaa;text-transform:uppercase;font-weight:bold;margin-bottom:2px;letter-spacing:.04em;">Valor com Seguro (R$)</div>
                  <input type="text" v-model="carta.seguro" @input="mascaraSeguro($event, ci)" placeholder="Ex: 3.100,00" style="width:100%;padding:6px 8px;border:1px solid #e0e0e0;border-radius:6px;font-size:13px;margin:0;" />
                </div>
              </div>
            </div>
          </div>

          <div style="border-top:1px solid #eee;padding-top:14px;margin-top:14px;">
            <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:6px;">
              <label style="font-size:12px;font-weight:bold;color:#555;margin:0;">OBSERVAÇÕES <span style="font-weight:normal;color:#aaa;">(opcional)</span></label>
              <div style="display:flex;gap:4px;background:#f0f0f0;border-radius:8px;padding:3px;">
                <button type="button" @click="modoObs = 'final'" :style="{ margin: 0, padding: '5px 12px', fontSize: '11px', borderRadius: '6px', background: modoObs === 'final' ? '#4a5c2f' : 'transparent', color: modoObs === 'final' ? 'white' : '#666' }">No final</button>
                <button type="button" @click="modoObs = 'carta'" :style="{ margin: 0, padding: '5px 12px', fontSize: '11px', borderRadius: '6px', background: modoObs === 'carta' ? '#4a5c2f' : 'transparent', color: modoObs === 'carta' ? 'white' : '#666' }">Por carta</button>
              </div>
            </div>
            <textarea v-if="modoObs === 'final'" v-model="prObs" placeholder="Ex: Proposta válida por 5 dias úteis. Condições sujeitas à aprovação." style="width:100%;padding:10px 12px;margin:6px 0 0;border:1px solid #e0e0e0;border-radius:8px;font-size:13px;height:72px;resize:vertical;line-height:1.6;color:#333;background:#fafafa;"></textarea>
            <div v-else style="display:flex;flex-direction:column;gap:8px;margin-top:6px;">
              <div v-for="(carta, ci) in cartas" :key="ci">
                <div style="font-size:10px;color:#888;font-weight:bold;margin-bottom:2px;">Obs. — Carta {{ ci + 1 }} ({{ carta.segmento }})</div>
                <textarea v-model="carta.obs" placeholder="Observação para esta cota/carta..." style="width:100%;padding:8px 10px;border:1px solid #e0e0e0;border-radius:8px;font-size:12px;height:52px;resize:vertical;line-height:1.5;color:#333;background:#fafafa;"></textarea>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div style="font-size:11px;color:#888;text-align:center;margin-bottom:10px;text-transform:uppercase;letter-spacing:1px;">Pré-visualização</div>
          <div id="propostaPreview" style="background:white;border-radius:16px;overflow:hidden;box-shadow:0 8px 32px rgba(0,0,0,0.15);max-width:640px;margin:0 auto;font-family:'Segoe UI',Arial,sans-serif;" v-html="previewHtml"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { apiPost, getSession, getNomeEmpresaCache } from '../api'
import {
  parseVal, fmtBRL, novaCarta, CARD_COLORS, SEG_ICONS,
  simRecalcular, simRenderResultadoHtml, gerarHTMLSimulador,
  montarPreviewLiveHtml, takePendingEditProposta
} from '../propostaHelpers'
import { FileText, Trash2, TrendingUp, Camera, Settings, LockOpen, ArrowRight, Pencil, CreditCard, X } from 'lucide-vue-next'

export default {
  name: 'PaginaProposta',
  components: { FileText, Trash2, TrendingUp, Camera, Settings, LockOpen, ArrowRight, Pencil, CreditCard, X },
  data() {
    return {
      aba: 'proposta',
      prNomeCliente: '',
      prAdm: '',
      prObs: '',
      cartas: [novaCarta()],
      cores: CARD_COLORS,
      segmentos: Object.keys(SEG_ICONS),
      beneficiosConfig: { texto: '', visivel: false },
      modoObs: 'final',
      propostaAtualId: null,
      textoBtnSalvar: 'Salvar',
      simCreditoInput: '40.000,00',
      simLanceRpInput: '0',
      sim: { tipo: 'autoconv', cat: 'auto', prazo: 100, taxa: 12, fundo: 2, antec: 0, dil: 2 },
      simResultadoAtual: null,
      simHtmlAtual: null,
      simVisivelNaProposta: false,
      btnToggleSimVisivel: false,
      btnSoSimVisivel: false
    }
  },
  computed: {
    ehAdmin() { return getSession().perfil === 'admin' },
    nomeUsuario() { return getSession().nome || getSession().usuario },
    simInputs() {
      return {
        tipo: this.sim.tipo,
        credito: parseVal(this.simCreditoInput) || 40000,
        prazo: parseFloat(this.sim.prazo) || 100,
        taxa: parseFloat(this.sim.taxa) || 0,
        fundo: parseFloat(this.sim.fundo) || 0,
        antec: parseFloat(this.sim.antec) || 0,
        dil: parseInt(this.sim.dil) || 1,
        lanceRp: 0,
        lanceRp50: parseVal(this.simLanceRpInput) || 0,
        cat: this.sim.cat
      }
    },
    simResultCalc() { return simRecalcular(this.simInputs) },
    lanceInfoHtml() {
      var p = this.simInputs
      var lanceRpPct = p.credito > 0 ? (p.lanceRp50 / p.credito * 100) : 0
      var lanceTotalPct = 25 + lanceRpPct
      return '25% embutido + ' + lanceRpPct.toFixed(1) + '% próprio = <strong style="font-size:14px;">' + lanceTotalPct.toFixed(1) + '%</strong> total sobre o crédito'
    },
    lanceInfoCor() {
      var p = this.simInputs
      var lanceRpPct = p.credito > 0 ? (p.lanceRp50 / p.credito * 100) : 0
      var lanceTotalPct = 25 + lanceRpPct
      return lanceTotalPct >= 50 ? '#1d4ed8' : lanceTotalPct > 25 ? '#2980b9' : '#64748b'
    },
    simResultadoHtml() { return simRenderResultadoHtml(this.simInputs, this.simResultCalc) },
    previewHtml() {
      return montarPreviewLiveHtml({
        nome: this.prNomeCliente,
        adm: this.prAdm,
        obs: this.prObs,
        modoObs: this.modoObs,
        vendedorNome: this.nomeUsuario,
        beneficiosConfig: this.beneficiosConfig,
        cartas: this.cartas,
        simResultadoAtual: this.simResultadoAtual,
        simHtmlAtual: this.simHtmlAtual,
        simVisivelNaProposta: this.simVisivelNaProposta,
        nomeEmpresa: getNomeEmpresaCache()
      })
    }
  },
  created() {
    var pending = takePendingEditProposta()
    if (pending) {
      this._carregarPropostaNoFormulario(pending)
    }
  },
  methods: {
    parseVal,
    fmtBRL,
    adicionarCarta() { this.cartas.push(novaCarta()) },
    removerCarta(ci) { if (this.cartas.length <= 1) return; this.cartas.splice(ci, 1) },
    adicionarGrupoCarta(ci) { this.cartas[ci].grupos.push({ qtd: '', valor: '' }) },
    removerGrupoCarta(ci, gi) { if (this.cartas[ci].grupos.length <= 1) return; this.cartas[ci].grupos.splice(gi, 1) },
    toggleSeguro(e, ci) { if (!e.target.checked) this.cartas[ci].seguro = '' },
    _mascara(v) {
      var d = v.replace(/\D/g, '')
      if (!d) return ''
      var n = (parseInt(d) / 100).toFixed(2)
      return n.replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    },
    mascaraCredito(e, ci) { this.cartas[ci].credito = this._mascara(e.target.value) },
    mascaraGrupoValor(e, ci, gi) { this.cartas[ci].grupos[gi].valor = this._mascara(e.target.value) },
    mascaraSeguro(e, ci) { this.cartas[ci].seguro = this._mascara(e.target.value) || ' ' },
    mascaraSimCredito(e) { this.simCreditoInput = this._mascara(e.target.value) },
    mascaraSimLanceRp(e) { this.simLanceRpInput = this._mascara(e.target.value) },

    trocarAbaProposta(aba) { this.aba = aba },

    simUsarNaProposta() {
      var p = this.simInputs
      var r = this.simResultCalc
      var tipoSeg = { autoconv: 'Automóvel', automais: 'Automóvel', imovconv: 'Imóvel', imovmais: 'Imóvel' }
      var tipoNome = { autoconv: 'Convencional', automais: 'Mais por Menos', imovconv: 'Convencional', imovmais: 'Mais por Menos' }
      var seg = tipoSeg[p.tipo] || 'Automóvel'
      var credStr = p.credito.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      var fmtVal = function (v) { return isNaN(v) || !isFinite(v) ? '0,00' : v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }

      var grupos25 = []
      if (Math.abs(r.parcelaDemais25 - r.parcelaPrimeira25) > 0.01 && p.dil > 1) {
        grupos25.push({ qtd: String(p.dil), valor: fmtVal(r.parcelaPrimeira25) })
        grupos25.push({ qtd: String(p.prazo - p.dil), valor: fmtVal(r.parcelaDemais25) })
      } else {
        grupos25.push({ qtd: String(p.prazo), valor: fmtVal(r.parcelaDemais25) })
      }

      var grupos50 = []
      if (Math.abs(r.parcelaDemais50 - r.parcelaPrimeira50) > 0.01 && p.dil > 1) {
        grupos50.push({ qtd: String(p.dil), valor: fmtVal(r.parcelaPrimeira50) })
        grupos50.push({ qtd: String(p.prazo - p.dil), valor: fmtVal(r.parcelaDemais50) })
      } else {
        grupos50.push({ qtd: String(p.prazo), valor: fmtVal(r.parcelaDemais50) })
      }
      var lanceRp50 = p.lanceRp50 || 0
      var lancePct50 = r.lancePct50 || 0

      var carta25 = { segmento: seg, credito: credStr, taxa: String(p.taxa) + '%', fundo: String(p.fundo) + '%', grupos: grupos25, mostrarLiquido: true }
      var carta50 = { segmento: seg, credito: credStr, taxa: String(p.taxa) + '%', fundo: String(p.fundo) + '%', grupos: grupos50, mostrarLiquido: true }
      carta25._labelSimulador = 'Lance Fixo 25%'
      carta50._labelSimulador = 'Lance 50% / Livre' + (lanceRp50 > 0 ? ' (' + lancePct50.toFixed(1) + '% total)' : '')

      var temCartasExistentes = this.cartas.length > 0 && (this.cartas[0].credito || this.cartas[0].grupos[0].valor)
      if (temCartasExistentes) {
        if (confirm('Substituir a proposta atual com os dados do simulador?\n\nOK = Substituir\nCancelar = Adicionar às cartas já lançadas')) {
          this.cartas = [carta25, carta50]
        } else {
          this.cartas = this.cartas.concat([carta25, carta50])
        }
      } else {
        this.cartas = [carta25, carta50]
      }
      this.simHtmlAtual = gerarHTMLSimulador(p, r)
      this.simResultadoAtual = { inputs: p, result: r }
      this.prObs = 'Simulador Embracon — ' + tipoNome[p.tipo] + ' | Crédito: R$ ' + credStr + ' | Prazo: ' + p.prazo + 'x | Taxa: ' + p.taxa + '% | FR: ' + p.fundo + '%'
      this.simVisivelNaProposta = true
      this.btnToggleSimVisivel = true
      this.btnSoSimVisivel = true
      this.trocarAbaProposta('proposta')
    },

    toggleSimuladorNaProposta() { this.simVisivelNaProposta = !this.simVisivelNaProposta },

    limparPropostaAtual() {
      this.prNomeCliente = ''
      this.prAdm = ''
      this.prObs = ''
      this.modoObs = 'final'
      this.cartas = [novaCarta()]
      this.simHtmlAtual = null
      this.simResultadoAtual = null
      this.simVisivelNaProposta = false
      this.propostaAtualId = null
      this.btnToggleSimVisivel = false
      this.btnSoSimVisivel = false
    },

    _carregarPropostaNoFormulario(p) {
      var d = p.dados
      this.propostaAtualId = null // vira uma proposta independente (nova versão), como no original
      this.prNomeCliente = d.nomeCliente || d.cliente || ''
      this.prAdm = d.adm || ''
      this.prObs = d.obs || ''
      this.modoObs = d.modoObs || 'final'
      this.cartas = (d.cartas && d.cartas.length) ? d.cartas.map(function (c) {
        return { segmento: c.segmento || 'Automóvel', credito: c.credito || '', taxa: c.taxa || '', fundo: c.fundo || '', seguro: c.seguro || '', _seguroChecked: !!c.seguro, mostrarLiquido: c.mostrarLiquido !== false, grupos: (c.grupos && c.grupos.length) ? c.grupos : [{ qtd: '', valor: '' }], _labelSimulador: c._labelSimulador, obs: c.obs || '' }
      }) : [novaCarta()]
      this.aba = 'proposta'
    },

    exportarSoSimulador() {
      if (!this.simHtmlAtual) { alert('Nenhuma simulação ativa.'); return }
      var nome = this.prNomeCliente || 'Cliente'
      var html = '<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Simulação</title>' +
        '<style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:"Segoe UI",Arial,sans-serif;background:#f5f5f5;padding:24px;}' +
        '@media print{body{padding:8px;background:white;}@page{margin:10mm;size:A4}}</style>' +
        '</head><body>' +
        '<div style="max-width:900px;margin:0 auto;">' +
        '<div style="margin-bottom:12px;font-size:13px;color:#666;">Simulação para: <strong>' + nome + '</strong></div>' +
        this.simHtmlAtual +
        '</div></body></html>'
      var w = window.open('', '_blank')
      w.document.write(html)
      w.document.close()
      setTimeout(function () { w.print() }, 500)
    },

    gerarPDFProposta() {
      var prev = document.getElementById('propostaPreview')
      if (!prev) { alert('Pré-visualização vazia.'); return }
      var pag2 = ''
      if (this.simHtmlAtual) {
        pag2 = '<div style="page-break-before:always;background:white;padding:24px 28px;min-height:100vh;">' +
          '<div style="font-size:11px;color:#aaa;margin-bottom:12px;text-transform:uppercase;letter-spacing:1px;border-bottom:1px solid #eee;padding-bottom:8px;">Anexo — Detalhamento da Simulação Embracon</div>' +
          this.simHtmlAtual +
          '</div>'
      }
      var html = '<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Proposta</title>' +
        '<style>' +
        '*{box-sizing:border-box;margin:0;padding:0}' +
        'body{background:#f5f0e8;font-family:Arial Black,Arial,sans-serif;}' +
        '@media print{' +
        'body{margin:0;background:#f5f0e8;}' +
        '@page{margin:0;size:A4}' +
        '.pag2{background:white!important;}' +
        '}' +
        '</style>' +
        '</head><body>' +
        prev.outerHTML +
        (pag2 ? '<div class="pag2">' + pag2 + '</div>' : '') +
        '</body></html>'
      var w = window.open('', '_blank')
      w.document.write(html)
      w.document.close()
      setTimeout(function () { w.print() }, 800)
    },

    gerarImagemProposta() {
      var prev = document.getElementById('propostaPreview')
      if (!prev) { alert('Pré-visualização vazia. Preencha os dados primeiro.'); return }
      var container = document.createElement('div')
      container.style.cssText = 'position:fixed;left:-9999px;top:0;z-index:-1;background:#f5f0e8;width:680px;'
      var clonePreview = prev.cloneNode(true)
      container.appendChild(clonePreview)
      if (this.simHtmlAtual) {
        var simBloco = document.createElement('div')
        simBloco.style.cssText = 'background:white;padding:20px 24px;margin-top:0;'
        simBloco.innerHTML = '<div style="font-size:10px;color:#aaa;margin-bottom:10px;text-transform:uppercase;letter-spacing:1px;border-bottom:1px solid #eee;padding-bottom:6px;">Detalhamento da Simulação</div>' + this.simHtmlAtual
        container.appendChild(simBloco)
      }
      document.body.appendChild(container)
      if (typeof window.html2canvas !== 'undefined') {
        window.html2canvas(container, { scale: 2, useCORS: true, backgroundColor: '#f5f0e8', width: 680, windowWidth: 680 }).then(function (canvas) {
          document.body.removeChild(container)
          var link = document.createElement('a')
          link.download = 'proposta_' + Date.now() + '.png'
          link.href = canvas.toDataURL('image/png')
          link.click()
        }).catch(function () { document.body.removeChild(container) })
      } else {
        document.body.removeChild(container)
        var simHtml = this.simHtmlAtual
          ? '<div style="background:white;padding:20px 24px;">' +
            '<div style="font-size:10px;color:#aaa;margin-bottom:10px;text-transform:uppercase;letter-spacing:1px;border-bottom:1px solid #eee;padding-bottom:6px;">Detalhamento da Simulação</div>' +
            this.simHtmlAtual +
            '</div>'
          : ''
        var html = '<!DOCTYPE html><html><head><meta charset="UTF-8">' +
          '<style>body{margin:0;background:#f5f0e8;display:flex;justify-content:center;padding:20px;font-family:sans-serif;}.hint{text-align:center;color:#888;font-size:13px;margin-bottom:12px;}.wrap{width:680px;}</style></head>' +
          '<body><div class="wrap"><div class="hint">Clique com botão direito → Salvar imagem, ou use Print Screen</div>' + prev.outerHTML + simHtml + '</div></body></html>'
        var w = window.open('', '_blank')
        w.document.write(html)
        w.document.close()
      }
    },

    async salvarPropostaAtual() {
      var cliente = (this.prNomeCliente || '').trim()
      if (!cliente) { alert('Preencha o nome do cliente antes de salvar.'); return }
      var titulo = prompt('Título da proposta (opcional):', 'Proposta ' + cliente + ' — ' + new Date().toLocaleDateString('pt-BR'))
      if (titulo === null) return
      var dados = {
        id: this.propostaAtualId || undefined,
        vendedor: this.nomeUsuario,
        cliente: cliente,
        nomeCliente: cliente,
        titulo: titulo || ('Proposta ' + cliente),
        dataCriacao: new Date().toLocaleDateString('pt-BR') + ' ' + new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }),
        adm: this.prAdm,
        obs: this.prObs,
        modoObs: this.modoObs,
        cartas: this.cartas
      }
      try {
        const r = await apiPost('propostas/salvar', { vendedor: dados.vendedor, cliente: dados.cliente, titulo: dados.titulo, id: dados.id, dados: JSON.stringify(dados) })
        if (r.sucesso) {
          this.propostaAtualId = r.id
          var orig = this.textoBtnSalvar
          this.textoBtnSalvar = 'Salvo!'
          setTimeout(() => { this.textoBtnSalvar = orig }, 2000)
        } else {
          alert(r.mensagem || 'Erro ao salvar proposta.')
        }
      } catch (e) { alert('Erro de conexão ao salvar proposta.') }
    }
  }
}
</script>
